<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>Profile and Preferences</h2>
          <p class="temp">
            We are currently unable to allow changes to your address and contact
            details via our website. Please contact
            <b>+44 20 34755351 (Europe)</b> or
            <b>+604 200 0554 (Americas)</b>.<br />
          </p>

          <div class="profEdit">
            <p>
              We will never sell or release your data to anyone. Please confirm
              your communication preferences.<br />
              These can be changed online should you wish.<br />
              I am happy to be kept up to date with BONUS offers for this
              programme by:
            </p>
          </div>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>
        <div v-if="showPreferencesForm === true" class="profEditBox">
          <div class="profEditBoxRow triggers">
            <div class="email">
              <div class="trigger">
                <input
                  type="checkbox"
                  id="email-checkbox"
                  v-model="emails"
                  v-on:change="updateNotificationSettings"
                />
                <label id="button" for="email-checkbox">
                  <div id="knob"></div>
                  <div id="subscribe">ON</div>
                  <div id="alright">OFF</div>
                </label>
              </div>
              <span>Email</span>
            </div>
            <div class="letter">
              <div class="trigger">
                <input
                  type="checkbox"
                  id="letter-checkbox"
                  v-on:change="updateNotificationSettings"
                  v-model="letter"
                />
                <label id="button" for="letter-checkbox">
                  <div id="knob"></div>
                  <div id="alright">OFF</div>
                  <div id="subscribe">ON</div>
                </label>
              </div>
              <span>Letter</span>
            </div>
          </div>
          <div class="profEditBoxRow2 triggers">
            <div class="phone">
              <div class="trigger">
                <input
                  type="checkbox"
                  id="phone-checkbox"
                  v-on:change="updateNotificationSettings"
                  v-model="phone"
                />
                <label id="button" for="phone-checkbox">
                  <div id="knob"></div>
                  <div id="alright">OFF</div>
                  <div id="subscribe">ON</div>
                </label>
              </div>
              <span>Phone</span>
            </div>
            <div class="sms">
              <div class="trigger">
                <input
                  type="checkbox"
                  id="sms-checkbox"
                  v-model="sms"
                  v-on:change="updateNotificationSettings"
                />
                <label id="button" for="sms-checkbox">
                  <div id="knob"></div>
                  <div id="alright">OFF</div>
                  <div id="subscribe">ON</div>
                </label>
              </div>
              <span>SMS Text Message</span>
            </div>
          </div>
          <div class="spacer-60"></div>
        </div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import actions from "@/store/accounts/actions";
import Cards from "./Cards.vue";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
    this.showPreferencesForm =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showProfilePreferences === true);
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    note: {
      get() {
        return this.$store.state.vehicles.vehicle?.note;
      },
      set(value) {
        this.$store.commit("updateVehicleNoteMutation", value);
      }
    },
    emails: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user
          ?.notificationSettings.emails;
      },
      set(value) {
        this.$store.commit(
          "updateAccountSettingsNotificationEmailsMutation",
          value
        );
      }
    },
    phone: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user
          ?.notificationSettings.phone;
      },
      set(value) {
        this.$store.commit(
          "updateAccountSettingsNotificationPhoneMutation",
          value
        );
      }
    },
    sms: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user
          ?.notificationSettings.sms;
      },
      set(value) {
        this.$store.commit(
          "updateAccountSettingsNotificationSmsMutation",
          value
        );
      }
    },
    letter: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user
          ?.notificationSettings.letter;
      },
      set(value) {
        this.$store.commit(
          "updateAccountSettingsNotificationLetterMutation",
          value
        );
      }
    }
  },
  methods: {
    updateNotificationSettings: async function() {
      const formedPayload = {
        emails: this.emails,
        phone: this.phone,
        sms: this.sms,
        letter: this.letter
      };

      await this.$store.dispatch(
        actions.UPDATE_NOTIFICATION_SETTINGS,
        formedPayload
      );
    }
  }
};
</script>
